import React from "react";

function MyTeam() {
  return <div>MyTeam</div>;
}

export default MyTeam;
